export default "__VITE_ASSET__c1baee0e__"